import { createAppSlice } from '../../app/createAppSlice'

const initialState = {
    "compositionId": "",
    "compositionTitle": "",
    "researchStudyJson": {},
    "researchStudyReference": {},
    "populationReference": {},
    "populationDescriptionGroupReference": {},
    "analyzedGroupReference": {},
    "enrolledGroupReference": {},
    "interventionGroupReference": {},
    "interventionDescriptionReference": {},
    "comparatorGroupReference": {},
    "comparatorDescriptionReference": {},
    "groupAssignmentReference": {},
    "synthesisPopulationReference": {},
    "synthesisInterventionDescriptionReference": {},
    "synthesisComparatorDescriptionReference": {},
    "screenedGroupReference": {},
    "excludedGroupReference": {},
    "groupReferencesDictionary": {},
    "outcomeMeasuresReportReference": {},
    "participantFlowReportReference": {},
    "baselineMeasuresReportReference": {},
    "summaryOfFindingsReference": {},
    "outcomeMeasures": [],
    "baselineMeasures": [],
    "participantFlowMeasures": [],
    "outcomeVariablesListReference": {},
    "participantFlowVariablesListReference": {},
    "baselineVariablesListReference": {},
    "combinedDictionary": {},
    "evidenceDisplayDictionary": {},
    "picoClassifiers": {
        populationArray: [],
        interventionArray: [],
        comparatorArray: [],
        outcomeArray: []
    }
};

const comparativeEvidenceMapSlice = createAppSlice({
    name: "comparativeEvidenceMap",
    initialState,
    reducers: create => ({
        changeComparativeEvidenceMap: create.reducer((state, action) => {
            let body = action.payload;
            state.compositionId = body.compositionId;
            state.compositionTitle = body.compositionTitle;
            state.researchStudyJson = body.researchStudyJson;
            state.researchStudyReference = body.researchStudyReference;
            state.populationReference = body.populationReference;
            state.populationDescriptionGroupReference = body.populationDescriptionGroupReference;
            state.analyzedGroupReference = body.analyzedGroupReference;
            state.enrolledGroupReference = body.enrolledGroupReference;
            state.interventionGroupReference = body.interventionGroupReference;
            state.interventionDescriptionReference = body.interventionDescriptionReference;
            state.comparatorGroupReference = body.comparatorGroupReference;
            state.comparatorDescriptionReference = body.comparatorDescriptionReference;
            state.groupAssignmentReference = body.groupAssignmentReference;
            state.synthesisPopulationReference = body.synthesisPopulationReference;
            state.synthesisInterventionDescriptionReference = body.synthesisInterventionDescriptionReference;
            state.synthesisComparatorDescriptionReference = body.synthesisComparatorDescriptionReference;
            state.screenedGroupReference = body.screenedGroupReference;
            state.excludedGroupReference = body.excludedGroupReference;
            state.groupReferencesDictionary = body.groupReferencesDictionary;
            state.outcomeMeasuresReportReference = body.outcomeMeasuresReportReference;
            state.participantFlowReportReference = body.participantFlowReportReference;
            state.baselineMeasuresReportReference = body.baselineMeasuresReportReference;
            state.summaryOfFindingsReference = body.summaryOfFindingsReference;
            state.outcomeMeasures = body.outcomeMeasures;
            state.baselineMeasures = body.baselineMeasures;
            state.participantFlowMeasures = body.participantFlowMeasures;
            state.outcomeVariablesListReference = body.outcomeVariablesListReference;
            state.participantFlowVariablesListReference = body.participantFlowVariablesListReference;
            state.baselineVariablesListReference = body.baselineVariablesListReference;
            state.combinedDictionary = body.combinedDictionary;
            state.evidenceDisplayDictionary = body.evidenceDisplayDictionary;
            state.picoClassifiers = body.picoClassifiers;
        }),
    }),
    selectors: {
        selectComparativeEvidenceMap: comparativeEvidenceMap => comparativeEvidenceMap
    },
})

export const { changeComparativeEvidenceMap } = comparativeEvidenceMapSlice.actions

export const { selectComparativeEvidenceMap } = comparativeEvidenceMapSlice.selectors

export default comparativeEvidenceMapSlice